// extracted by mini-css-extract-plugin
export default {"MessageContentLeft":"styles_MessageContentLeft__SN0LZ","MessageContentRight":"styles_MessageContentRight__CJNmQ"};